import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { useRef, useState } from "react";
import PrimeDialog from "../../../components/dialog/PrimeDialog";
import { AddManufacture } from "./dialog/AddManufacture";
import { useForm } from "react-hook-form";

export const Manufacture = () => {
    const fileInputRef = useRef(null);
    const [addDialog,setAddDialog] = useState(false);
    
    const { getValues, 
        setValue, 
        control,
        clearErrors, 
        register, 
        handleSubmit, 
        formState: { errors,isValid } } = useForm({
    defaultValues: {
     
    },
     //錯誤驗證時機
    mode: "all"
  })
    return(<>
        <Button label="新增" onClick={()=>setAddDialog(true)}></Button>
        <PrimeDialog
            visible={addDialog}
            title="新增"
            size="lg"
            onClose={() => { setAddDialog(false) }}
            onConfirm={() => { setAddDialog(false) }}
            bodyTemplate={<AddManufacture
                register = {register}
                errors = {errors}
                control = {control}
                setValue = {setValue}
                fileInputRef={fileInputRef}
            ></AddManufacture>}
        ></PrimeDialog>
    </>)
}